import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import "./style.css";
import { TextField } from "@mui/material";

export const MultipleCheckbox = ({ el, filterParams, setFilterParams }) => {
  const dispatch = useDispatch();

  const [renderedData, setRenderedData] = useState(el.fields || []);

  const addFields = (fieldName) => (e) => {
    const { checked, value } = e.target;

    const data = checked
      ? [...(filterParams[fieldName] || []), value]
      : (filterParams[fieldName] || []).filter((el) => el !== value);

    dispatch(setFilterParams({ ...filterParams, [fieldName]: data }));
  };

  const changeHandler = (e) =>
    setRenderedData(
      Object.keys(el.fields).filter((el) =>
        el.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );

  return (
    <Fragment>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {el?.searchable && (
          <TextField
            label="Search"
            variant="standard"
            type="search"
            style={{ width: 300 }}
            onChange={changeHandler}
          />
        )}
        {renderedData.map((data, id) => {
          return (
            <FormControlLabel
              className="label_checkbox_filter"
              key={id}
              label={data.label}
              control={
                <Checkbox
                  sx={{ p: 0, m: 1 }}
                  value={`${data.value}`}
                  checked={filterParams[el.fieldName]?.includes(
                    `${data.value}`
                  )}
                  onChange={addFields(el.fieldName)}
                  icon={<CheckIcon />}
                  checkedIcon={<CheckIcon />}
                />
              }
            />
          );
        })}
      </Box>
    </Fragment>
  );
};
